<template>
    <section>
        <b-modal :title="title" v-model="open" ref="modal" size="lg">
            <div class="alarm-sections">
                <div class="alarm-section">
                    <h2>{{$t('message.suspicious_consumption_fluctuation')}}</h2>
                    <p class="alarm-section__desc">{{$t('message.suspicious_consumption_fluctuation_desc')}}</p>
                    <div class="alarm-section__action flex items-center gap-2">
                        <toggle-button v-model="difference" :sync="true" :labels="{checked: 'On', unchecked: 'Off'}" />
                        <span v-if="difference"> {{$t('message.active')}} </span>
                        <span v-else> {{$t('message.inactive')}} </span>
                    </div>
                    <div v-if="difference" class="alarm-section__action flex items-center gap-2">
                        <toggle-button v-model="alertOnNegative" :sync="true" :labels="{checked: 'On', unchecked: 'Off'}" />
                        <span>{{$t('message.alert_on_negative_consumption')}}</span>
                    </div>
                </div>

                <div class="alarm-section">
                    <h2>{{$t('message.consumption_last_hour')}}</h2>
                    <p class="alarm-section__desc">{{$t('message.consumption_last_hour_desc')}}</p>
                    <last-hour :unit="unit" v-for="(event, index) in $data['last-hour']" :key="event.id || 'last-hour-new-' + index" :event="event" :event-changed="eventChanged"/>
                    <div class="alarm-section__action">
                        <b-btn class="btn-add" @click="addEvent('last-hour')">{{$t('message.add_alarm')}}</b-btn>
                    </div>
                </div>

                <div class="alarm-section">
                    <h2>
                        Součet spotřeby po minutách
                    </h2>
                    <p class="alarm-section__desc">
                        Vyhodnocováno s přesností na minuty.
                    </p>
                    <last-minutes :unit="unit" v-for="(event, index) in $data['last-minutes']" :key="event.id || 'last-minutes-new-' + index" :event="event" :event-changed="eventChanged"/>
                    <div class="alarm-section__action">
                        <b-btn class="btn-add" @click="addEvent('last-minutes')">{{$t('message.add_alarm')}}</b-btn>
                    </div>
                </div>

                <div v-if="false" class="alarm-section">
                    <h2>{{$t('message.current_flow')}}</h2>
                    <p class="alarm-section__desc">{{$t('message.current_flow_desc')}}</p>
                    <actual :unit="unit" v-for="(event, index) in actual" :key="event.id || 'actual-new-' + index" :event="event" :event-changed="eventChanged" />
                    <div class="alarm-section__action">
                        <b-btn class="btn-add" @click="addEvent('actual')">{{$t('message.add_alarm')}}</b-btn>
                    </div>
                </div>

                <div class="alarm-section">
                    <h2>{{$t('message.water_consumption_time_interval')}}</h2>
                    <p class="alarm-section__desc">{{$t('message.water_consumption_time_interval_desc')}}</p>
                    <sum :unit="unit" v-for="(event, index) in sum" :key="event.id || 'sum-new-' + index" :event="event" :event-changed="eventChanged" />
                    <div class="alarm-section__action">
                        <b-btn class="btn-add" @click="addEvent('sum')">{{$t('message.add_alarm')}}</b-btn>
                    </div>
                </div>

                <div v-if="false" class="alarm-section">
                    <h2>{{$t('message.continuous_water_flow')}}</h2>
                    <p class="alarm-section__desc">{{$t('message.continuous_water_flow_desc')}}</p>
                    <flow :unit="unit" v-for="(event, index) in flow" :key="event.id || 'flow-new-' + index" :event="event" :event-changed="eventChanged" />
                    <div class="alarm-section__action">
                        <b-btn class="btn-add" @click="addEvent('flow')">{{$t('message.add_alarm')}}</b-btn>
                    </div>
                </div>

                <div class="alarm-section">
                    <h2>
                        Nepřetržitá spotřeba
                    </h2>
                    <p class="alarm-section__desc">
                        Vyhodnocováno s přesností na minuty.
                        Např. přetečená vana
                    </p>
                    <continuous :unit="unit" v-for="(event, index) in continuous" :key="event.id || 'continuous-new-' + index" :event="event" :event-changed="eventChanged"/>
                    <div class="alarm-section__action">
                        <b-btn class="btn-add" @click="addEvent('continuous')">{{$t('message.add_alarm')}}</b-btn>
                    </div>
                </div>
            </div>
            <template #footer>
                <b-btn @click="open=false">{{$t('message.ok')}}</b-btn>
            </template>
        </b-modal>
    </section>
</template>

<script>
    import LastHour from './alarm/LastHour'
    import LastMinutes from './alarm/LastMinutes.vue'
    import Actual from './alarm/Actual'
    import Continuous from './alarm/Continuous.vue'
    import Sum from './alarm/Sum'
    import Flow from './alarm/Flow'
    import mixins from '../../../modules/mixins'
    import {ALARM_REQUEST} from '../../../_store'
    import eventBus from '../../../modules/eventBus'

    export default {
        name: 'Alarm',
        components: {
            LastHour,
            LastMinutes,
            Actual,
            Continuous,
            Sum,
            Flow
        },
        props: {
            unit: {
                type: String
            }
        },
        mixins: [mixins],
        data () {
            return {
                initialized: false,
                open: false,
                item: null,
                difference: false,
                alertOnNegative: false,
                'last-hour': [],
                'last-minutes': [],
                'continuous': [],
                actual: [],
                sum: [],
                flow: [],
                title: 'Alarmová hlášení',
                water: null
            }
        },
        methods: {
            show (item, water) {
                this.water = water
                const waterType = this.unit === 'watts' ? this.$t('message.electricity') : this.getWaterTypeText(water)
                this.initialized = false
                this.item = item
                this.open = true
                const path = (item.path || item.name || '').toString().trim()
                this.title = [this.$t('message.alarm_reports'), path, waterType]
                    .filter(part => part)
                    .join(' - ')
                this.$store.dispatch(ALARM_REQUEST, {
                    entity: item.id,
                    type: item.type,
                    action: 'read',
                    water: this.water,
                    medium: this.unit === 'watts' ? 'power' : 'water'
                }).then(resp => {
                    const data = resp.data
                    for (let key of ['last-hour', 'actual', 'sum', 'flow', 'last-minutes', 'continuous']) {
                        this[key] = data[key]
                    }
                    this.applyDifference(data.difference)
                    this.$nextTick(() => {
                        this.item.alarms = this.hasAlarms()
                        // this.addEvent('last-hour')
                        // this.addEvent('actual')
                        // this.addEvent('sum')
                        // this.addEvent('flow')
                        this.initialized = true
                    })
                })
            },
            addEvent (eventType) {
                const defaultEvents = {
                    'last-hour': {
                        saved: false,
                        id: null,
                        type: 'last-hour',
                        comparision: 'gt',
                        liters: 0
                    },
                    'last-minutes': {
                        saved: false,
                        id: null,
                        type: 'last-minutes',
                        comparision: 'gt',
                        liters: 0
                    },
                    'actual': {
                        saved: false,
                        id: null,
                        type: 'actual',
                        comparision: 'gt',
                        liters: 0
                    },
                    'sum': {
                        saved: false,
                        id: null,
                        type: 'sum',
                        comparision: 'gt',
                        liters: 0,
                        start: '8:00',
                        end: '18:00',
                        source: 'auto'
                    },
                    'flow': {
                        saved: false,
                        id: null,
                        type: 'flow',
                        liters: 0
                    },
                    'continuous': {
                        saved: false,
                        id: null,
                        type: 'continuous',
                        liters: 0
                    }
                }
                this[eventType].push(defaultEvents[eventType])
            },
            applyDifference (value) {
                if (value && typeof value === 'object') {
                    this.difference = !!value.enabled
                    this.alertOnNegative = !!value.alertOnNegative
                    return
                }
                this.difference = !!value
                this.alertOnNegative = false
            },
            differencePayload () {
                return {
                    type: 'difference',
                    alertOnNegative: this.alertOnNegative
                }
            },
            getWaterTypeText (water) {
                switch (water) {
                case 'total':
                    return this.$t('message.cold_and_hot_water')
                case 'cold':
                    return this.$t('message.cold_water')
                case 'hot':
                    return this.$t('message.hot_water')
                }
            },
            eventChanged (action, event) {
                if (action === 'marked_to_delete') {
                    if (event.type !== 'difference') {
                        const index = this[event.type].indexOf(event)
                        this[event.type].splice(index, 1)
                    }
                    if (event.type === 'difference' || event.id != null) {
                        this.$store.dispatch(ALARM_REQUEST, {
                            entity: this.item.id,
                            type: this.item.type,
                            water: this.water,
                            data: event,
                            action: 'destroy',
                            medium: this.unit === 'watts' ? 'power' : 'water'
                        }).then(resp => {
                            this.item.alarms = this.hasAlarms()
                        })
                    }
                } else if (action === 'marked_to_save') {
                    if (event.id > 0) {
                        this.$store.dispatch(ALARM_REQUEST, {
                            entity: this.item.id,
                            type: this.item.type,
                            water: this.water,
                            data: event,
                            action: 'destroy',
                            medium: this.unit === 'watts' ? 'power' : 'water'
                        }).then(resp => {
                            this.item.alarms = this.hasAlarms()
                        })
                    }
                    const request = {
                        entity: this.item.id,
                        type: this.item.type,
                        water: this.water,
                        data: event,
                        action: 'create',
                        medium: this.unit === 'watts' ? 'power' : 'water'
                    }
                    this.$store.dispatch(ALARM_REQUEST, request)
                        .then(resp => {
                            event.id = resp.data.object.id
                            event.saved = true
                            this.item.alarms = this.hasAlarms()
                        })
                }
            },
            hasAlarms () {
                let sum = 0
                for (let key of ['last-hour', 'actual', 'sum', 'flow']) {
                    for (let i of this[key]) {
                        sum += i.saved ? 1 : 0
                    }
                }
                return this.difference || sum > 0
            }
        },
        watch: {
            difference (d) {
                if (!this.initialized) {
                    return
                }
                this.eventChanged(d ? 'marked_to_save' : 'marked_to_delete', this.differencePayload())
            },
            alertOnNegative () {
                if (!this.initialized || !this.difference) {
                    return
                }
                this.eventChanged('marked_to_save', this.differencePayload())
            },
            open (open) {
                if (!open) {
                    eventBus.emit('reload-alerts', {})
                }
            }
        },
        created () {
            // this.addEvent('last-hour')
            // this.addEvent('actual')
            // this.addEvent('sum')
            // this.addEvent('flow')
        }
    }
</script>

<style scoped>
    .alarm-sections {
        margin: -4px 0;
    }

    .alarm-section {
        padding: 22px 0;
        border-bottom: 1px solid #e5e5e5;
    }

    .alarm-section:last-child {
        border-bottom: 0;
        padding-bottom: 8px;
    }

    .alarm-section:first-child {
        padding-top: 8px;
    }

    .alarm-section h2 {
        margin: 0 0 6px;
        font-size: 22px;
        font-weight: 700;
        line-height: 1.25;
        color: #333;
    }

    .alarm-section__desc {
        margin: 0 0 12px;
        font-size: 13px;
        line-height: 1.45;
        color: #777;
    }

    .alarm-section__action {
        margin-top: 4px;
    }

    .control-inline {
        display: inline-block;
        max-width: 75px;
    }

    .btn-add {
        margin: 0;
    }
</style>
